const PetitionError = require('../../petitionError');
const { get } = require('../../httpRequester');

class GetThirdPartyTokenException extends PetitionError {
  constructor(code) {
    super('Get third party token', code);
  }
}

async function getThirdPartyToken(token) {
  const response = await get('users/third_party_token', token);

  if (response.result !== GetThirdPartyTokenException.success) {
    throw new GetThirdPartyTokenException(response.result);
  } else {
    return response.user;
  }
}

module.exports = { getThirdPartyToken, GetThirdPartyTokenException };
